import { api } from './api';
import { RateRequest, RateResponse } from '../types/rate';

export const rateService = {
  async calculateRates(userId: string, rateData: RateRequest): Promise<RateResponse[]> {
    const response = await api.post<RateResponse[]>(`/users/${userId}/rate`, rateData);
    return response.data;
  },
};